import type { Trip } from "./types";

export function destinationImage(trip: Trip) {
  return trip.hero_image || "/images/destination-generic.svg";
}

export function tripDateRange(trip: Trip) {
  if (!trip.start_date && !trip.end_date) return "Dates open";
  const formatter = new Intl.DateTimeFormat("en", { day: "numeric", month: "short", year: "numeric" });
  const format = (value: string | null) => value ? formatter.format(new Date(`${value}T00:00:00`)) : "Open";
  return `${format(trip.start_date)} — ${format(trip.end_date)}`;
}

export function googleMapsLocationUrl(point: { latitude: string; longitude: string }) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${point.latitude},${point.longitude}`)}`;
}
